module.exports = __webpack_public_path__ + "static/media/phone-plus.8cbe7b99.svg";